import {
  EmailAuthProvider,
  linkWithCredential,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
} from "firebase/auth";

/**
 * Firebase 네이티브 이메일/비밀번호.
 * 익명 사용자에 link 하면 uid 가 그대로 유지된다.
 */
export default {
  id: "email",
  label: "이메일로 계속하기",
  kind: "native",

  credential({ email, password }) {
    if (!email || !password) throw new Error("이메일과 비밀번호가 필요합니다.");
    return EmailAuthProvider.credential(email, password);
  },

  link(user, opts) {
    return linkWithCredential(user, this.credential(opts));
  },

  signIn(auth, { email, password }) {
    return signInWithEmailAndPassword(auth, email, password);
  },

  /**
   * 비밀번호 재설정 메일.
   *
   * ★ 없는 이메일이라고 알려주면 안 된다 — 어떤 이메일이 가입돼 있는지
   * 확인해 주는 꼴이라 계정 열거가 열린다. 성공·실패를 같은 얼굴로 돌려준다.
   * (Firebase 의 이메일 열거 방지가 켜져 있으면 애초에 던지지도 않는다)
   */
  async reset(auth, { email }) {
    if (!email) throw new Error("이메일이 필요합니다.");
    try {
      await sendPasswordResetEmail(auth, email);
    } catch (e) {
      if (e?.code === "auth/user-not-found" || e?.code === "auth/invalid-email") return;
      throw e;
    }
  },
};
